import { ReactNode } from "react";
import { Image } from "./Image";

interface Props {
  // Null indicating that the file exists but we can't decrypt it.
  file: File | string | null;
  type?: string;
  // Used when no preview is available
  children: ReactNode;
}

export function FilePreviewDisplay({ file, type, children }: Props) {
  // Preview images
  if (type?.startsWith("image/") && file !== null) {
    return <Image className="fit" src={file} />;
  }
  // Caller chooses how to display unknown types
  return children;
}
